// 方案三：紫色系 - 智慧、创新、专业
// 适合：教育平台、创新职业测评，传达智慧和创新
export const professionalPurpleTheme = {
  colors: {
    'psychology-primary': '#7C3AED',      // 深紫色 - 智慧、创新、专业
    'psychology-secondary': '#6D28D9',    // 更深紫色 - 辅助色，稳重
    'psychology-accent': '#8B5CF6',       // 亮紫色 - 强调色，活力
    'psychology-calm': '#F5F3FF',         // 极浅紫色 - 背景色，优雅
    'psychology-warm': '#EDE9FE',         // 浅紫色 - 温暖背景
    'psychology-success': '#10B981',      // 绿色 - 成功、积极
    'psychology-info': '#8B5CF6',         // 紫色 - 信息状态
    'psychology-warning': '#F59E0B',      // 橙色 - 警告状态
  },
  name: 'professional-purple',
  description: '紫色系主题 - 智慧、创新、专业，适合教育平台'
}

